const organAccountPage = [
    {
        path: "/organizationProcess",
        redirect:'/organizationProcess/orgInfoChild',
        component: () => import("@views/orgAccount/orgInfo.vue"),
        meta: {
            title: "机构相关信息",
            showBg: false,
            tag:0
        },
        children:[
            {
                path: "orgInfoChild",
                name: "机构相关信息",
                component: () => import("@views/orgAccount/orgInfo/orgInfoChild.vue"),
                meta:{
                    orgTag:0,
                    notReturnBtn:true
                }
            },
            {
                path: "representativeInfo",
                name: "机构相关信息",
                component: () => import("@views/orgAccount/orgInfo/representativeInfo.vue"),
                meta:{
                    orgTag:0,
                    notReturnBtn:true
                }
            },
            {
                path: "agentInfo",
                name: "机构相关信息",
                component: () => import("@views/orgAccount/orgInfo/agentInfo.vue"),
                meta:{
                    orgTag:0,
                    notReturnBtn:true
                }
            },
            {
                path: "benefitInfo",
                name: "机构相关信息",
                component: () => import("@views/orgAccount/orgInfo/beneficraryInfo.vue"),
                meta:{
                    orgTag:0,
                    notReturnBtn:true
                }
            },
            {
                path: "shareholderInfo",
                name: "机构相关信息",
                component: () => import("@views/orgAccount/orgInfo/shareholderInfo.vue"),
                meta:{
                    orgTag:0,
                    notReturnBtn:true
                }
            },
            {
                path: "orgTax",
                name: "税收身份声明",
                component: () => import("@views/orgAccount/orgInfo/orgTax.vue"),
                meta: {
                    orgTag:1,
                    notReturnBtn:true
                },
            },
            {
                path: "orgHoldTax",
                name: "税收身份声明",
                component: () => import("@views/orgAccount/orgInfo/orgHoldTax.vue"),
                meta: {
                    orgTag:1,
                    notReturnBtn:true
                },
            },
            {
                path: "bindBank",
                name: "绑定银行账户",
                component: () => import("@views/orgAccount/orgInfo/bindBank.vue"),
                meta: {
                    title: "机构开户",
                    orgTag:2,
                    notReturnBtn:true,
                    showPhoneIcon: true
                },
            },
            {
                path: "riskAssessment",
                name: "风险测评",
                component: () => import("@views/orgAccount/orgInfo/riskAssessment.vue"),
                meta: {
                    title: "机构开户",
                    orgTag:3,
                    notReturnBtn:true
                },
            },
            {
                path: "riskResult",
                name: "风险测评",
                component: () => import("@views/orgAccount/orgInfo/riskResult.vue"),
                meta: {
                    title: "机构开户",
                    orgTag:3,
                    notReturnBtn:true
                },
            },
            {
                path: "investorIdentification",
                name: "投资者类型认定",
                component: () => import("@views/orgAccount/orgInfo/investorIdentification.vue"),
                meta:{
                    orgTag:4,
                    notReturnBtn:true
                }
            },
            {
                path: "uploadMaterial",
                name: "投资者类型认定",
                component: () => import("@views/orgAccount/orgInfo/uploadMaterial.vue"),
                meta:{
                    orgTag:4,
                    questionName:'uploadExample'
                }
            },
            {
                path: "platformAuthentication",
                name: "电子签约平台认证",
                component: () => import("@views/orgAccount/orgInfo/platformAuthentication.vue"),
                meta:{
                    orgTag:5,
                    skipStep:{
                        stepName:'platformAuthentication'
                    },
                    notReturnBtn:true
                }
            }
        ]
    },
    {
        path: "riskQuestion",
        name: "风险匹配说明",
        component: () => import("@views/orgAccount/orgInfo/riskQuestion.vue"),
        meta: {
        title: "个人信息",
        },
    },
    {
        path: "bankList",
        name: "银行列表",
        component: () => import("@views/orgAccount/bankList.vue")
    },
    {
        path: "branchList",
        name: "选择支行",
        component: () => import("@views/orgAccount/branchList.vue")
    },
    {
        path: "orgRisk",
        name: "风险测评",
        component: () => import("@views/orgAccount/orgPersonalCenter/riskAssessment.vue"),
        meta: {
            title: "个人中心",
            returnFlag:'need'
        },
    },
    {
        path: "orgRiskResult",
        name: "风险测评",
        component: () => import("@views/orgAccount/orgPersonalCenter/riskResult.vue"),
        meta: {
            title: "个人中心",
            keepAlive:true,
            returnFlag:'need'
        },
    },
    {
        path: "orgCertificationRisk",
        name: "风险测评",
        component: () => import("@views/orgAccount/orgCertification/riskAssessment.vue"),
        meta: {
            title: "一键认证",
            singleHead: true,
        },
    },
    {
        path: "orgCertificationRiskResult",
        name: "风险测评结果",
        component: () => import("@views/orgAccount/orgCertification/riskResult.vue"),
        meta: {
            title: "一键认证",
            singleHead: true,
        },
    },
    {
        path: "orgCertificationInvestor",
        name: "合格投资者认定",
        component: () => import("@views/orgAccount/orgCertification/investorIdentification.vue"),
        meta:{
            singleHead: true,
            title: "一键认证",
        }
    },
    {
        path: "orgCertificationMaterial",
        name: "合格投资者认定",
        component: () => import("@views/orgAccount/orgCertification/uploadMaterial.vue"),
        meta:{
            singleHead: true,
            title: "一键认证",
        }
    },
    {
        path: "orgInvestor",
        name: "合格投资者认定",
        component: () => import("@views/orgAccount/orgPersonalCenter/investorIdentification.vue"),
        meta:{
            // notReturnBtn:true
            title: "",
            singleHead: true,
        }
    },
    {
        path: "orgUploadMaterial",
        name: "合格投资者认定",
        component: () => import("@views/orgAccount/orgPersonalCenter/uploadMaterial.vue"),
        meta:{
            title: "",
            singleHead: true,
        }
    },
    {
        path: "handledbyInfo",
        name: "授权经办人信息",
        component: () => import("@views/orgAccount/orgPersonalCenter/handledbyInfo.vue"),
        meta:{
            title: "",
            singleHead: true,
        }
    },
    {
        path: "handledbyInfoEdit",
        name: "授权经办人信息修改",
        component: () => import("@views/orgAccount/orgPersonalCenter/handledbyInfoEdit.vue"),
        meta:{
            title: "",
            singleHead: true,
            // keepAlive:true,
        }
    },
    {
        path: "uploadInfo",
        name: "证件有效期",
        component: () => import("@views/orgAccount/orgPersonalCenter/uploadInfo.vue"),
        meta:{
            title: "",
            singleHead: true,
        }
    },
    {
        path: "orgCenterTax",
        name: "税收身份声明",
        component: () => import("@views/orgAccount/orgPersonalCenter/orgTax.vue"),
        meta: {
            notReturnBtn:true
        },
    },
]
export default organAccountPage